import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Logo } from "../logo/Logo";
import Collection from "../collection/Collection";
import {
  getPublicShared,
  getPublicMultiShared,
  navigatePublicSharedFolder
} from "../../actions/AssetsPublicSharedAction";
import Pagination from "../pagination/Pagination";
import queryString from "query-string";
import BigFooter from "../footer/BigFooter";
import { Modal, Alert, Input, Icon, Spin } from "antd";
import {
  sendNotification,
  NOT_FOUND_STATUS,
  UNAUTHORIZED_ERROR,
  launchDownload,
  ENDPOINT
} from "../../utils/index";
import jwtDecode from "jwt-decode";
// import DownloadMultiple from '../assets-download/DownloadMultiple'
import DownloadProgressNotification from "../assets-download/DownloadProgressNotification";
import {
  downloadError,
  updateDownload,
  resetDownloadReducer,
  handleSaveDownload
} from "../../actions/DownloadAction";
import axios from "axios";
import FileExtension from "file-extension";
import moment from "moment";
import DownloadModal from "../multi-selector-header-options/download-modal/DownloadModal";
import { individualClear } from "../../actions/IndividualSelectAction";
import Socket from "../../utils/sockets";
import MultiDownloadModalFolder from "../multi-selector-header-options/MultiDownloadModalFolder";
import { cancelSelect } from "../../actions/MultiselectAction";

export class Shared extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
      passwordIsOk: false,
      password: "",
      showModal: false,
      userWhoShared: null,
      sharedAssetExpiration: null,
      folderSharedSelect: null,
      objectSharedType: "",
      cancelDownloads: [],
      showExpirationAlert: false,
      showNotFoundAlert: false,
      multiple: false,
      accessToken: null
    };
  }

  componentDidMount() {
    const socketInstance = Socket.getInstance();

    // Socket listen to multi download zip url
    socketInstance.on("server_lambda_download_multiple", data => {
      if (data.env) {
        return;
      }
      this.handleMultipleFileLambdaResponse(data);
    });
    // Socket listen to single file download url
    socketInstance.on("server_lambda_download_single", data => {
      this.handleSingleFileLambdaResponse(data);
    });
    socketInstance.on("server_lambda_download_not_zip_folder", data => {
      this.handleSingleFileLambdaResponse(data);
    });
    socketInstance.on("server_download_unavailable", data => {
      const currentDownload = this.props.dataDownload.find(
        download => download.uuid === data.uuid
      );
      if (currentDownload) {
        this.props.downloadError(data.uuid);
        sendNotification(
          "error",
          this.props.intl,
          this.props.intl.formatMessage({ id: "rights_asset_out" })
        );
      }
    });
    const { intl } = this.props;
    let qs = queryString.parse(this.props.location.search);

    if (qs && qs.webToken) {
      this.setState({
        multiple: qs.multiple === "1"
      });
      if (qs.multiple === "1") {
        this.props.getPublicMultiShared(qs.webToken, intl, "");
      } else {
        this.props.getPublicShared(qs.webToken, intl, "");
      }
      if (qs.extraData) {
        this.setState({
          userWhoShared: jwtDecode(qs.extraData).emiter,
          sharedAssetExpiration: moment(jwtDecode(qs.extraData).expires).format(
            "DD/MM/YYYY"
          ),
          objectSharedType: jwtDecode(qs.extraData).objectSharedType
        });
      }
    } else {
      this.props.history.push("/logout");
    }
    const { wc } = this.props;
    if (!wc) {
      const { webToken } = qs;
      if (webToken) {
        axios
          .post(`${ENDPOINT}shared/validate`, { webToken })
          .then(resp => {
            const accessToken = resp.data.acssTkn
              ? resp.data.acssTkn
              : resp.data.accessToken;
            const decode = jwtDecode(accessToken);

            const client = decode.user.client;
            this.setState({ client, accessToken });
          })
          .catch(() => {});
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      error,
      assetHasPassword,
      accessToken,
      intl,
      wrongPassword,
      dataDownload
    } = this.props;

    if (
      error !== prevProps.error &&
      error.response.status === UNAUTHORIZED_ERROR
    ) {
      this.setState({ showExpirationAlert: true });
    } else if (
      error !== prevProps.error &&
      error.response.status === NOT_FOUND_STATUS
    ) {
      this.setState({ showNotFoundAlert: true });
    }

    if (assetHasPassword !== prevProps.assetHasPassword)
      this.setState({ showModal: true });

    if (accessToken !== prevProps.accessToken) {
      this.setState({
        showModal: false,
        passwordIsOk: true
      });
    }

    if (prevProps.dataDownload !== dataDownload) {
      dataDownload.forEach(asset => {
        if (asset.status === "started" && asset.type === "FILE") {
          this.handleDownloadS3File(asset.id, asset.name, asset.url);
        }
      });
    }

    if (wrongPassword !== prevProps.wrongPassword && wrongPassword === true) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "wrong_password" })
      );
    }
  }
  handleMultipleFileLambdaResponse = data => {
    const { status = "success", id: asset, url } = data;
    // const status = 'success';
    // const asset = '8rNeljj8OO3uOOmxAAAB';
    // const url = 'http://bunkey-qa.s3.us-east-2.amazonaws.com/test/archive-1696432731513.zip';
    const urlArray = [
      {
        url: url
      }
    ];
    const { dataDownload, intl } = this.props;
    const currentDownload = dataDownload.find(f => f.uuid === asset);
    if (currentDownload) {
      if (status === "success") {
        launchDownload(urlArray);
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_starting_download" })
        );
      }
      this.props.cancelSelect();
      this.props.updateDownload(asset, status);
    }
  };
  handleSingleFileLambdaResponse = data => {
    const { status, urlArray } = data;
    const { dataDownload, intl } = this.props;
    const currentDownload = dataDownload.find(f => f.uuid === data.uuid);
    if (currentDownload) {
      if (status === "success") {
        launchDownload(urlArray);
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_starting_download" })
        );
      }
      this.props.updateDownload(data.uuid, status);
    }
  };

  handleChangePage = page => {
    const { password } = this.state;
    const { folderselect, foldername, webToken, sharedBreadCrumb } = this.props;
    this.setState(
      {
        activePage: page
      },
      () => {
        if (foldername && foldername !== "") {
          this.props.navigatePublicSharedFolder(
            webToken,
            folderselect,
            foldername,
            password,
            page
          );
        } else {
          const foldernameSelect = sharedBreadCrumb.find(
            r => r.id === folderselect
          );
          this.props.navigatePublicSharedFolder(
            webToken,
            folderselect,
            foldernameSelect.name,
            password,
            page
          );
        }
      }
    );
  };

  handlePasswordInput = e => {
    this.setState({
      password: e.target.value
    });
  };

  handleOk = () => {
    const { password, multiple } = this.state;
    const { intl } = this.props;
    let qs = queryString.parse(this.props.location.search);

    if (password !== "") {
      if (multiple) {
        this.props.getPublicMultiShared(qs.webToken, intl, password);
      } else {
        this.props.getPublicShared(qs.webToken, intl, password);
      }
    }
  };

  handleKeyPress = e => {
    if (e.key === "Enter") this.handleOk();
  };

  handleDownloadS3File = (id, name, url) => {
    const { cancelDownloads } = this.state;
    const CancelToken = axios.CancelToken;
    const arrCancelDownloads = cancelDownloads;
    let cancel = null;
    const fileName = name + "." + FileExtension(url);

    axios({
      url: url,
      method: "GET",
      headers: {
        "Cache-Control": "no-cache",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Content-Type, Authorization, Content-Length, X-Requested-With"
      },
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      responseType: "blob",
      requestId: url
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        this.props.updateDownload(id, name);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          this.props.resetDownloadReducer();
        } else {
          this.props.downloadError(id);
        }
      });
    arrCancelDownloads.push(cancel);
    this.setState({
      cancelDownloads: arrCancelDownloads
    });
  };

  handleCancelDownload = () => {
    const { cancelDownloads } = this.state;
    cancelDownloads.forEach(cancel => {
      cancel();
    });
    this.props.resetDownloadReducer();
  };

  render() {
    const {
      activePage,
      passwordIsOk,
      showModal,
      password,
      userWhoShared,
      sharedAssetExpiration,
      objectSharedType,
      showExpirationAlert,
      showNotFoundAlert,
      accessToken,
      client
    } = this.state;
    const {
      isFetching,
      nameSharedAsset,
      dataDownload,
      headers,
      intl,
      isDownloadFolder
    } = this.props;
    const assetsDownloading = dataDownload.filter(r => r.status !== "finished");
    const { selectedFile, action } = this.props;

    return (
      <React.Fragment>
        <div className="menu" style={{ backgroundColor: "#2E97CF" }}>
          {!isDownloadFolder && assetsDownloading.length > 0 && (
            <DownloadProgressNotification
              handleCancelDownload={this.handleCancelDownload}
            />
          )}
          <div className="container" ref={this.containerRef}>
            <div className="search-bar">
              <div>
                <Logo privLogo={true} />
              </div>
              <img
                alt="Bunkey"
                src="/images/bunkey-logo-mobile.svg"
                className="bunkey-logo-mobile"
              />
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
                height: "100%"
              }}
            >
              {!isFetching &&
                !showNotFoundAlert &&
                !showExpirationAlert &&
                sharedAssetExpiration && (
                  <div
                    style={{
                      display: "flex",
                      backgroundColor: "#fff",
                      alignItems: "center",
                      borderRadius: "4px",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      height: "28px"
                    }}
                  >
                    <span>
                      {intl.formatMessage({ id: "available_until" })}{" "}
                      {sharedAssetExpiration}
                    </span>
                  </div>
                )}
              <br />
              <a href="https://dam.bunkey.tv" style={{ color: "#ffff" }}>
                {intl.formatMessage({ id: "go_to_bunkey" })}
              </a>
            </div>
          </div>
        </div>
        <br />
        <br />
        <Modal
          centered={true}
          visible={showModal}
          onOk={this.handleOk}
          cancelButtonProps={{ disabled: true }}
          okButtonProps={{ disabled: false }}
        >
          <Alert
            message={intl.formatMessage({ id: "alert_warning_attention" })}
            description={intl.formatMessage({ id: "asset_password" })}
            type="info"
            banner={false}
            showIcon={true}
            icon={
              <Icon
                type="lock"
                style={{ fontSize: "25px", marginTop: "10px" }}
              />
            }
          />
          <Input.Password
            className="input-password"
            placeholder={intl.formatMessage({ id: "login_password" })}
            value={password}
            onChange={this.handlePasswordInput}
            onKeyPress={this.handleKeyPress}
          />
        </Modal>

        {isFetching ? (
          <Spin
            style={{ marginTop: "85px", display: "inherit" }}
            spinning={true}
          />
        ) : (
          <div>
            {showNotFoundAlert && !showExpirationAlert && (
              <div className="container" style={{ marginTop: "3%" }}>
                <Alert
                  message={intl.formatMessage({ id: "not_available" })}
                  description={intl.formatMessage({
                    id: "not_found_shared_link"
                  })}
                  type="error"
                  showIcon
                />
              </div>
            )}

            {!showNotFoundAlert && showExpirationAlert && (
              <div className="container" style={{ marginTop: "3%" }}>
                <Alert
                  message={intl.formatMessage({ id: "expired_link" })}
                  description={
                    intl.formatMessage({
                      id: "this_link_was_available_until"
                    }) +
                    " " +
                    sharedAssetExpiration +
                    "."
                  }
                  type="warning"
                  showIcon
                />
              </div>
            )}

            {!showNotFoundAlert &&
              !showExpirationAlert &&
              passwordIsOk &&
              nameSharedAsset && (
                <React.Fragment>
                  <div className="container" style={{ marginTop: "3%" }}>
                    <Alert
                      message={intl.formatMessage({ id: "information" })}
                      description={intl.formatMessage({
                        id: "for_download_folder"
                      })}
                      type="info"
                      showIcon
                    />
                  </div>
                  <Collection
                    title={nameSharedAsset}
                    filter={["folder", "document", "image", "video"]}
                    view="vertical"
                    password={password}
                    isFetching={isFetching}
                    keyCollection="assetsPublicShared"
                    userWhoShared={userWhoShared}
                    sharedAssetExpiration={sharedAssetExpiration}
                    style={{ backgroundColor: "#2E97CF" }}
                    objectSharedType={objectSharedType}
                  ></Collection>
                </React.Fragment>
              )}
            {!showNotFoundAlert && !showExpirationAlert && passwordIsOk && (
              <Pagination
                handleChangePage={this.handleChangePage}
                activePage={activePage}
                page={activePage}
                headers={headers}
              />
            )}
          </div>
        )}
        <BigFooter />
        {this.props.show && (
          <MultiDownloadModalFolder
            showModal={this.props.show}
            accessToken={accessToken}
            clientShared={client}
          />
        )}
        {/* <DownloadMultiple /> */}
        {selectedFile && action === "download" && (
          <DownloadModal
            showModal={action === "download"}
            handleHiddenModal={() => {
              this.props.individualClear();
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.assetsPublicShared.data,
    error: state.assetsPublicShared.error,
    headers: state.assetsPublicShared.headers,
    isFetching: state.assetsPublicShared.isFetching,
    nameSharedAsset: state.assetsPublicShared.nameSharedAsset,
    folderselect: state.assetsPublicShared.folderselect,
    webToken: state.assetsPublicShared.webToken,
    sharedBreadCrumb: state.assetsPublicShared.sharedBreadCrumb,
    assetHasPassword: state.assetsPublicShared.assetHasPassword,
    accessToken: state.assetsPublicShared.accessToken,
    wrongPassword: state.assetsPublicShared.wrongPassword,
    dataDownload: state.downloads.data,
    isDownloadFolder: state.downloads.isDownloadFolder,
    selectedFile: state.individualSelect.selectedFile,
    action: state.individualSelect.action,
    show: state.downloads.showResumeDownload,
    id: state.downloads.showResumeDownloadId
  };
};

const mapDispatchToProps = {
  getPublicShared,
  getPublicMultiShared,
  navigatePublicSharedFolder,
  resetDownloadReducer,
  downloadError,
  updateDownload,
  individualClear,
  handleSaveDownload,
  cancelSelect
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Shared))
);
